var cookies = require('js-cookie')

module.exports = function fieldsCallme (uniformData) {
  var checkbox = null
  var phone = null
  var leadUrl = null
  var firstName = null
  var lastName = null
  var zipCode = null
  var trackedCookies = ['extcsasid', '_ga', '_gid', '_fbp', 'aam_exponea', 'aam_uuid']
  var _formFieldsLookup = uniformData.formFields.reduce(function (fields, field) {
    if (isFieldCheckbox(field)) {
      checkbox = field
    } else if (isFieldCPhone(field)) {
      phone = field
    } else if (isFirstName(field)) {
      firstName = field
    } else if (isLastName(field)) {
      lastName = field
    } else if (isZipCode(field)) {
      zipCode = field
    } else if (isFieldLeadUrl(field)) {
      leadUrl = field
    }
    fields[field.id] = field
    return fields
  }, {})

  function isFieldCheckbox (field) {
    return field.fieldType === 'checkbox'
  }

  function isFieldCPhone (field) {
    var ret = false
    try {
      ret = field.fieldType === 'textbox' &&
            (field.validation.validationType === 'tel.cislo' ||
             field.validation.validationType === 'tel.Bez1/8')
    } catch (e) {}
    return ret
  }

  function isFirstName (field) {
    var ret = false
    try {
      ret = field.businessName === 'firstName'
    } catch (e) {}
    return ret
  }

  function isLastName (field) {
    var ret = false
    try {
      ret = field.businessName === 'lastName'
    } catch (e) {}
    return ret
  }

  function isZipCode (field) {
    var ret = false
    try {
      ret = field.businessName === 'zipCode'
    } catch (e) {}
    return ret
  }

  function isFieldLeadUrl (field) {
    var ret = false
    try {
      ret = field.nameI18N === 'Zdroj leadu'
    } catch (e) {}
    return ret
  }

  function onValueChanged (value, formFieldId) {
    _formFieldsLookup[formFieldId].value = value
  }

  function getSubmitFields () {
    return Object.keys(_formFieldsLookup).map(function (id) {
      return {
        fieldId: id,
        values: [_formFieldsLookup[id].value]
      }
    })
  }

  function setValuesByDefaultValueI18N (obj) {
    if (typeof obj === 'object' && obj !== null) {
      var keys = Object.keys(_formFieldsLookup)
      for (var i = 0, l = keys.length; i < l; i++) {
        var field = _formFieldsLookup[keys[i]]
        var value = obj[field.defaultValueI18N]
        if (typeof value !== 'undefined') {
          field.value = value
        }
      }
    }
  }

  function setValuesByBusinessName (obj) {
    if (typeof obj === 'object' && obj !== null) {
      var keys = Object.keys(_formFieldsLookup)
      for (var i = 0, l = keys.length; i < l; i++) {
        var field = _formFieldsLookup[keys[i]]
        var value = obj[field.businessName]
        if (typeof value !== 'undefined') {
          field.value = value
        }
      }
    }
  }

  function setValuesToHiddenCookieFields () {
    var keys = Object.keys(_formFieldsLookup)
    for (var i = 0; i < keys.length; i++) {
      if (_formFieldsLookup[keys[i]].businessName) {
        if (trackedCookies.indexOf(_formFieldsLookup[keys[i]].businessName) !== -1) {
          _formFieldsLookup[keys[i]].value = cookies.get(_formFieldsLookup[keys[i]].businessName)
        }
      }
    }
  }

  function setValuesByURLParameters () {
    var keys = Object.keys(_formFieldsLookup)
    for (var i = 0; i < keys.length; i++) {
      if (_formFieldsLookup[keys[i]].businessName) {
        var param = getParameterByName(_formFieldsLookup[keys[i]].businessName)
        if (param) {
          _formFieldsLookup[keys[i]].value = param
        }
      }
    }
  }

  function setThemeClassesById (obj) {
    if (typeof obj === 'object' && obj !== null) {
      var keys = Object.keys(obj)
      for (var i = 0, l = keys.length; i < l; i++) {
        var field = _formFieldsLookup[keys[i]]
        field.themeClass = obj[keys[i]]
      }
    }
  }

  function setBackendErrorMessages (arr) {
    for (var i = 0, l = arr.length; i < l; i++) {
      var id = arr[i].fieldId
      _formFieldsLookup[id].messages = arr[i].messages
    }
  }

  function getParameterByName (name) {
    var url = window.location.href
    name = name.replace(/[[\]]/g, '\\$&')
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
    var results = regex.exec(url)
    if (!results) return null
    if (!results[2]) return ''
    return decodeURIComponent(results[2].replace(/\+/g, ' '))
  }

  return {
    setValuesByDefaultValueI18N: setValuesByDefaultValueI18N,
    setValuesByBusinessName: setValuesByBusinessName,
    setValuesToHiddenCookieFields: setValuesToHiddenCookieFields,
    setValuesByURLParameters: setValuesByURLParameters,
    setThemeClassesById: setThemeClassesById,
    setBackendErrorMessages: setBackendErrorMessages,
    onValueChanged: onValueChanged,
    getSubmitFields: getSubmitFields,
    buttonNameI18N: uniformData.buttonNameI18N,
    textBeforeWCM: uniformData.textBeforeWCM,
    textAfterSendingWCM: uniformData.textAfterSendingWCM,
    checkbox: checkbox,
    phone: phone,
    firstName: firstName,
    lastName: lastName,
    zipCode: zipCode,
    leadUrl: leadUrl
  }
}
